import React from "react";

import { graphql } from "gatsby";

import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";

import {
  Container,
  Content,
  CredentialsContainer,
  Illustration,
  Message,
  Quote,
  Wrapper,
} from "./SocialProofBlock.styles";

export interface SocialProofBlockProps extends Queries.SanitySocialProofBlock {}

const SocialProofBlock: React.FC<SocialProofBlockProps> = ({
  image,
  imageAlt,
  _rawQuote,
  name,
  occupation,
}) => (
  <Container>
    <Content>
      <Wrapper>
        {image && (
          <Illustration>
            <OptimizedImage image={image} alt={imageAlt} />
          </Illustration>
        )}

        <Message>
          <Quote>
            <RichText text={_rawQuote} />
          </Quote>
          <CredentialsContainer>
            <Text variant="H4" as="h4">
              {name}
            </Text>
            <Text variant="H4" as="h4">
              {occupation}
            </Text>
          </CredentialsContainer>
        </Message>
      </Wrapper>
    </Content>
  </Container>
);

export const query = graphql`
  fragment SocialProofBlock on SanitySocialProofBlock {
    _key
    _type
    image { ...OptimizedImage }
    imageAlt
    _rawQuote(resolveReferences: { maxDepth: 5 })
    name
    occupation
  }
`;

export default SocialProofBlock;
